import React, { useEffect, useState } from 'react';
import CardContent from '@mui/material/CardContent';
import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';
import {BiMessageRoundedCheck, BiMessageRoundedError} from 'react-icons/bi';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import { AiOutlineClose } from 'react-icons/ai';
import { IconContext } from "react-icons";
import Loading from '../../../../components/Loading';
import api from '../../../../services/api';
import { getToken } from '../../../../services/auth';

// import { Container } from './styles';

function Detalhes({setdetalhes, idAtendimento}) {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({
        atendimento: {
            date: null,
            status: null,
            solicitacao: null,
            datesolu: null,
            solucao: null,
            hoursolu: null,
            hour: null,
            tecnico: null,
            contato: null,
            protocolo: null,
            atendente: null
        },
        motivo: {
            id: null,
            nome: null
        },
        contrato: {
            id: null,
            nome: null
        }
    })
    useEffect(() => {
        const getAtendimento = async (id) => {
            setLoading(true)
            let token = await getToken();
            api.get(`/clients/attendance/` + id,{
                params: {
                    token,
                }
            }).then(function (response) {
                let dataTemp = response.data;
                console.log(dataTemp)
                setData(dataTemp)
                setLoading(false)
            }).catch(function(error){
                console.log(error)
            });
        }
        getAtendimento(idAtendimento)
    }, [idAtendimento]);
    return (
        <div className="col-sm-12 col-xs-12 col-12 col-md-12 col-lg-12 col-xl-12" style={{marginBottom: 20, marginTop: 20}}>
            <Loading open={loading} />
            <Paper elevation={12}>
                <div style={{cursor: "pointer", float: "right", marginRight: 15, marginTop: 10}} onClick={() => setdetalhes(0)}>
                    <IconContext.Provider value={{ color: "#a3a3a3", size: 20 }}>
                        <AiOutlineClose />
                    </IconContext.Provider>
                </div>
                <CardContent>
                    <Stack direction="row" spacing={2}>
                        {data.atendimento.status === "OK" ? (
                            <Avatar sx={{ backgroundColor: 'var(--main-bg-color)', width: 50, height: 50 }} >
                                <BiMessageRoundedCheck color={"var(--main-white-color)"} size={30} />
                            </Avatar>
                        ) : (
                            <Avatar sx={{ backgroundColor: 'transparent', width: 50, height: 50 }} >
                                <BiMessageRoundedError color={"#a3a3a3"} size={30} />
                            </Avatar>
                        )}
                        <Stack direction="column" spacing={0}>
                            <Typography gutterBottom variant="body2" component="div">
                                Protocolo: {data.atendimento.protocolo}
                            </Typography>
                            <Typography gutterBottom variant="body2" component="div">
                                Status: {data.atendimento.status}
                            </Typography>
                        </Stack>
                    </Stack>
                    <Typography variant="body2" style={{marginTop: 10}}>
                        Motivo: {data.motivo.nome}
                    </Typography>
                    <Typography variant="body2" style={{marginTop: 10}}>
                        Contrato: {data.contrato.id} - {data.contrato.nome}
                    </Typography>
                    <Typography variant="body2" style={{marginTop: 10}}>
                        Atendente: {data.atendimento.atendente}
                    </Typography>
                    <Typography variant="body2" style={{marginTop: 10}}>
                        Abertura: {data.atendimento.date} {data.atendimento.hour}
                    </Typography>
                    <Typography variant="body2" style={{marginTop: 10}}>
                        Fechamento: {data.atendimento.datesolu} {data.atendimento.hoursolu}
                    </Typography>
                </CardContent>
            </Paper>
        </div>
    )
    
}

export default Detalhes;